import axios from "axios";
import ModeService from './mode.service';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { "Content-Type": "application/json", Accept: "application/json" },
});

// Add Authorization token interceptor
api.interceptors.request.use(async (config) => {
  const token = await localStorage.getItem("api_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (config.data instanceof FormData) {
    // Let the browser set the multipart boundary for file uploads
    delete config.headers["Content-Type"];
  }
  return config;
});

const request = async (method: any, url: any, data = null, params = {}, mode: boolean = true) => {
  try {
    const fullUrl = (mode ? await ModeService.getModeFr() : "") + url;
    const response = await api({ method, url: fullUrl, data, params });
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

const apiService = {
  get: (url: any, params: any = {}, mode = true) => request("get", url, null, params, mode),
  post: (url: any, data: any = {}, mode = true) => request("post", url, data, {}, mode),
  put: (url: any, data: any, mode = true) => request("put", url, data, {}, mode),
  delete: (url: any, mode = true) => request("delete", url, null, {}, mode),

  setAccessToken: async (token: string) => {
    await localStorage.setItem("api_token", token);
    api.defaults.headers.Authorization = `Bearer ${token}`;
  },

  getAccessToken: async () => {
    return await localStorage.getItem("api_token");
  },
};

// Centralized Error Handler
const handleApiError = (error: any) => {
  if (error.response) {
    switch (error.response.status) {
      case 500:
        console.error("Internal Server Error");
        break;
      case 404:
        console.error("Resource Not Found");
        break;
      case 401:
        console.error("Unauthorized Access");
        localStorage.removeItem("api_token");
        break;
      default:
        console.error("API Error:", error.response.status);
    }
  } else if (error.request) {
    console.error("No response received:", error.request);
  } else {
    console.error("Request Error:", error.message);
  }
};

export default apiService;
